export default "__VITE_ASSET__C5J0WCzz__"